<template>
<div>
    <dropDown nodeId="dealer-codes-select" :label="label('dealerCodes')" :class="$style.dropDown" v-on:selection="selection" :name="'dealerCode'" :items="list_dealer_codes"/>
</div>
</template>

<script>
import dropDown from './dropDown/dropDown.vue';

export default {
    name: 'dealerCode',
    props: {
        dealerCodes: {
            type: Array,
            required: true
        }
    },
    components: {
        dropDown
    },
    methods: {
        selection: function(data){
            this.$emit('selection',data);
        },
        label: function(key){
            return this.$Localization.str(key);
        },        
    },
    computed: {
        list_dealer_codes: function(){
            var list = [];
            for(let i=0; i<this.dealerCodes.length; i++){
                var code = this.dealerCodes[i];
                list.push({
                    id: code,
                    name: code
                })
            }
            return list;
        },
    }

}
</script>

<style module>
.dropDown select option:checked{
    font-weight: bold !important;
}
</style>